import { Component, OnInit, Inject } from '@angular/core';
import {Subject} from "rxjs";
import {BsModalRef} from "ngx-bootstrap";
import {BlockModel, DagSourceModel} from "@app/workflow-common/services/DagSourceModel";
import {
    AddBlockInitialStateInterface
} from "@app/workflow-common/diagram-view2/models/add-block-initial-state.interface";
import {Blocks} from "@app/workflow-common/services/Blocks";

@Component({
    selector: 'app-add-task-side-panel',
    templateUrl: './add-task-side-panel.component.html',
    styleUrls: ['./add-task-side-panel.component.scss']
})
export class AddTaskSidePanelComponent implements OnInit, AddBlockInitialStateInterface {

    public onClose: Subject<any>;
    dagSourceModel: DagSourceModel;

    activeBlockName:string = '';
    activeBlockObject: BlockModel = undefined;

    title: string;
    workflowType: string;
    isEdit: boolean = false;
    objectName: string = '';
    stageName: string = '';
    stageId: number = undefined;
    blocksList: any[] = [];
    blockId: string = '';
    parentId: string = '';
    actionType:string;
    isActive: boolean;
    deleteMessage: string = 'The automation must be disabled before deleting this action. Do you want to deactivate?';
    isConditionalBlock: boolean = false;
    isElseBlock: boolean = false;

    tableTypeName:string;
    tableTypeId: number = undefined;
    conditionalColName: string = '';
    hasChildren: boolean = false;
    screenName:string;
    insertBetween: boolean = false;

    constructor(
      public modalRef: BsModalRef,
      @Inject('confirmationBoxHelper') private confirmationBoxHelper,
      @Inject('$scope') private ajsScope
    ) { }

    ngOnInit() {
        this.onClose = new Subject<any>();
        this.blocksList = this.dagSourceModel.getBlocksSource().getBlockList(this.workflowType, this.objectName, this.actionType, this.screenName);
        const activeBlock = this.dagSourceModel.getBlockByBlockId(this.blockId);
        if(activeBlock && this.isEdit) {
            this.activeBlockName = activeBlock['name'];
            this.resolveActiveBlockObject(activeBlock);
            this.isEdit = true;
        }
        else if(this.actionType === 'on_stage_change') {
            const stageChangeBlock = this.dagSourceModel.getBlocksSource().getBlockByKey('actionBlocks_changeStageBlock');
            this.activeBlockName = stageChangeBlock['name'];
            this.resolveActiveBlockObject(stageChangeBlock);
        }
        if(this.workflowType === Blocks.WORKFLOW_TYPE_CONSTANTS['custom_automation']) {
            this.isConditionalBlock = this.isEdit ? activeBlock['isConditional'] : activeBlock['name'] == "conditionalBlock";
        }

        if(this.isConditionalBlock && activeBlock) {
            const { condition } = activeBlock;
            this.conditionalColName = this.isEdit && condition ? condition['col_name'] : activeBlock['model']['col_name'];
            console.log('conditionalColName', this.conditionalColName);
        }

    }
    onCloseModal() {
        this.modalRef.hide();
    }

    closeWidgetModal(data:{}) {
        if(data['action'] == 'close') {
            if(this.isEdit) {
                this.modalRef.hide();
            }
            else {
                this.activeBlockObject = undefined;
                this.activeBlockName = '';
            }
        }
        else if(data['action'] == 'close_all') {
            this.modalRef.hide();
        }
        else if(data['action'] == 'save_and_close') {
            const blockData = data['data'];
            if(this.workflowType === Blocks.WORKFLOW_TYPE_CONSTANTS['custom_automation']) {
                this.onClose.next(data);
            }
            else {
                this.dagSourceModel.addTask(blockData, this.parentId);
                this.onClose.next(blockData);
            }
        }
        else if(data['action'] == 'remove_block') {
            this.onClose.next(data);
        }
    }

    showBlockPanel(blockData:{}) {
        // not allow multiple clicks
        if(this.activeBlockName == blockData['name']) {
            return;
        }
        this.activeBlockName = blockData['name'];
        this.resolveActiveBlockObject(blockData);
    }

    resolveActiveBlockObject(blockData) {
        const cloneBlockData = {...blockData};
        if(!blockData.parentId) {
            blockData.parentId = this.parentId;
        }
        this.activeBlockObject = new BlockModel(cloneBlockData);
    }
}
